import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import SyncDisabledIcon from '@mui/icons-material/SyncDisabled'
import { Box, Chip, List, ListItem, Tooltip, Typography } from '@mui/material'
import { FC, useMemo } from 'react'
import { useGetList, useRecordContext, useTranslate } from 'react-admin'
import { Samenwerking, ZaakDocument } from '../../types/apiRequests'

const DocumentsPanel: FC = () => {
  const translate = useTranslate()
  const record = useRecordContext<Samenwerking>()

  const { data, isLoading, error } = useGetList<ZaakDocument>(
    `documenten/${record?.id}`,
    {
      filter: {},
      pagination: { page: 1, perPage: 100 },
    }
  )

  const filteredDocs = useMemo(
    () => (data ?? []).filter(doc => doc.bron === 'dso' || doc.synced),
    [data]
  )

  if (isLoading) return <div />
  if (error) {
    return (
      <Typography color="error">
        {translate('ra.notification.http_error')}
      </Typography>
    )
  }

  return (
    <List disablePadding>
      {filteredDocs.map((doc) => (
        <ListItem key={doc.id} sx={{ flexDirection: 'column', alignItems: 'flex-start', py: 1 }}>
          <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
            {doc.name}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ wordBreak: 'break-word' }}>
            {doc.mimetype}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
            <Chip
              size="small"
              label={doc.bron === 'zaken' ? translate('data.sourceZaken') : translate('data.sourceDso')}
              color={doc.bron === 'zaken' ? 'primary' : 'default'}
              variant="outlined"
            />
            <Tooltip title={doc.synced ? translate('show.synced') : translate('show.notSynced')}>
              {doc.synced
                ? <CheckCircleIcon color="success" fontSize="small" />
                : <SyncDisabledIcon color="disabled" fontSize="small" />}
            </Tooltip>
          </Box>
        </ListItem>
      ))}
      {filteredDocs.length === 0 && (
        <Typography variant="body2" color="textSecondary" sx={{ p: 1 }}>
          {translate('show.noDocuments')}
        </Typography>
      )}
    </List>
  )
}

export default DocumentsPanel
